export const ActionTypes = {
    GEOLOCATION_COMPLETED: '@@search/geolocation/COMPLETED',
    SEARCH_COMPLETED: '@@search/search/COMPLETED',
    SEARCH_FAILED: '@@search/search/FAILED',
    SEARCH_STARTED: '@@search/search/STARTED',
    SET_SESSION_ID: '@@search/SET_SESSION_ID',
    SET_TRACKING_ID: '@@search/SET_TRACKING_ID',
    TRACK_DOCTOR_CARD_CLICK: '@@search/tracking/TRACK_DOCTOR_CARD_CLICK',
    TRACK_FILTER_ADDITIONAL_CRITERIA_CLICK: '@@search/tracking/TRACK_FILTER_ADDITIONAL_CRITERIA_CLICK',
    TRACK_FILTER_LANGUAGE_CLICK: '@@search/tracking/TRACK_FILTER_LANGUAGE_CLICK',
    TRACK_FILTER_SORT_MATCHES_CLICK: '@@search/tracking/TRACK_FILTER_SORT_MATCHES_CLICK',
    TRACK_FILTER_SPECIAL_HOURS_CLICK: '@@search/tracking/TRACK_FILTER_SPECIAL_HOURS_CLICK',
    TRACK_MAP_CLICK: '@@search/tracking/TRACK_MAP_CLICK',
    TRACK_MOBILE_MAP_TOGGLE_CLICK: '@search/TRACK_MOBILE_MAP_TOGGLE_CLICK',
    TRACK_MORE_FILTERS_CLICK: '@search/TRACK_MORE_FILTERS_CLICK',
    TRACK_PAGINATION_NUMBER_CLICK: '@@search/tracking/TRACK_PAGINATION_NUMBER_CLICK',
    TRACK_PPS_CHANGE: '@@search/tracking/TRACK_PPS_CHANGE',
    TRACK_PPS_CLICK: '@@search/tracking/TRACK_PPS_CLICK',
    TRACK_PPS_FOCUS: '@@search/tracking/TRACK_PPS_FOCUS',
    TRACK_PPS_SELECT: '@@search/tracking/TRACK_PPS_SELECT',
    TRACK_REFINE_SEARCH_CLICK_SPECIALTY_DROPDOWN: '@@search/tracking/TRACK_REFINE_SEARCH_CLICK_SPECIALTY_DROPDOWN',
    TRACK_REFINE_SEARCH_SELECT_SPECIALTY: '@@search/tracking/TRACK_REFINE_SEARCH_SELECT_SPECIALTY',
    TRACK_REFINE_SEARCH_CLICK_PROCEDURE_DROPDOWN: '@@search/tracking/TRACK_REFINE_SEARCH_CLICK_PROCEDURE_DROPDOWN',
    TRACK_REFINE_SEARCH_SELECT_PROCEDURE: '@@search/tracking/TRACK_REFINE_SEARCH_SELECT_PROCEDURE',
    TRACK_REFINE_SEARCH_CLICK_GENDER: '@@search/tracking/TRACK_REFINE_SEARCH_CLICK_GENDER',
    TRACK_REVIEWS_READ_MORE_TOGGLE: '@@search/tracking/TRACK_REVIEWS_READ_MORE_TOGGLE',
    TRACK_SEARCH: '@@search/tracking/TRACK_SEARCH',
    TRACK_THEMED_SEARCH_CLICK: '@@search/tracking/TRACK_THEMED_SEARCH_CLICK',
    TRACK_TIMESGRID_CLICK_MORE_TIMES: '@@search/tracking/TRACK_TIMESGRID_CLICK_MORE_TIMES',
    TRACK_TIMESGRID_CLICK_NEXT_AVAILABLE: '@@search/tracking/TRACK_TIMESGRID_CLICK_NEXT_AVAILABLE',
    TRACK_TIMESGRID_CLICK_NEXT_DAYS: '@@search/tracking/TRACK_TIMESGRID_CLICK_NEXT_DAYS',
    TRACK_TIMESGRID_CLICK_PREV_DAYS: '@@search/tracking/TRACK_TIMESGRID_CLICK_PREV_DAYS',
    TRACK_TIMESGRID_CLICK_TIME_SLOT: '@@search/tracking/TRACK_TIMESGRID_CLICK_TIME_SLOT',
    TRACK_TIMESGRID_CLICK_PHONE_NUMBER: '@@search/tracking/TRACK_TIMESGRID_CLICK_PHONE_NUMBER',
    TRACK_TIMESGRID_LOADED: '@@search/tracking/TRACK_TIMESGRID_LOADED',
    UPDATE_PARAMETERS: '@@search/search/UPDATE_PARAMETERS',
    UPDATE_PENDING_PARAMETERS: '@@search/search/UPDATE_PENDING_PARAMETERS',
};

export const PedlActions = {
    THEMED_SEARCH_ALLERGIST_CLICK: 'Themed Search Allergist Click',
    THEMED_SEARCH_PEDIATRICIAN_CLICK: 'Themed Search Pediatrician Click',
    THEMED_SEARCH_PHYSICAL_CLICK: 'Themed Search Physical Click',
    THEMED_SEARCH_THERAPIST_CLICK: 'Themed Search Therapist Click',
};
